import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import DatePickerComponent from "../../components/Datepicker";
import FireAssuranceContext from "./FireAssuranceContext";
import SelectComponent from "../../components/Select";
import ProvincesComponent from "../../components/Provinces";
import ProvincesOtherComponent from "../../components/ProvincesOther";
import { RELATIONS } from "../../data/global";
import { BANKS, BENEFITS } from "../../data/fireAssurance";
import InputMask from "react-input-mask";
import { DateUtils } from "../../utils";
import { DATETIME_SEARCH_FORMAT } from "../../const";
import AddRound from "../../images/add_round.svg";
import DelRound from "../../images/del_round.svg";
import moment from "moment";
import { SpaceBox } from "../../components/Space";
import { Step3Langague } from "../../data/locale";
import DataService from "../../service/data";
import NameThComponent from "../../components/Customer/NameTh";
import InfoIconComponent from "../../components/InfoIcon";

class FireAssuranceStep2 extends Component {
  state = {
    benefitTitles: [],
    nationals: []
  };
  titles = [];

  constructor(props) {
    super(props);
    setTimeout(() => {
      this.initData();
    }, 1);
  }

  async initData() {
    try {
      const callers = [];
      callers.push(DataService.getTitle({ lang: "", type: "B" }));
      callers.push(DataService.getNationalities());
      callers.push(DataService.getOccupations());

      const responses = await Promise.all(callers);
      this.titles = responses[0];
      const benefitTitles = this.titles.filter(data => data.lang === "TH");

      this.setState({
        ...this.state,
        benefitTitles: benefitTitles,
        nationals: responses[1],
        occupations: responses[2]
      });
    } catch (err) {
      console.log(err);
    }
  }

  _getTitles(sSex, lang) {
    return this.titles.filter(
      title => title.gender === sSex && title.lang === lang
    );
  }

  _getLang(field) {
    return Step3Langague[field]["th"];
  }
  _renderPresonForm() {
    const { benefitTitles } = this.state;
    const { diffDateAssurance, step2 } = this.context;
    const {
      sIDNo,
      sSex,
      sInitNameTH,
      sFirstNameTH,
      sLastNameTH,
      sBirthDate,
      sOccupation,
      sMobile,
      sEmail,
      sStart_date,
      sEnd_date,
      onChangeModel,
      onChangeDateModel
    } = step2;
    const today = new Date(DateUtils.getCurrentPlusOneTh(null, "YYYY-MM-DD"));
    const insure_maxDate = new Date(
      moment(today)
        .add(1, "months")
        .format(DATETIME_SEARCH_FORMAT)
    );
    const maxDate = new Date(
      moment(today)
        .subtract(15, "years")
        .format(DATETIME_SEARCH_FORMAT)
    );
    const minDate = new Date(
      moment(today)
        .subtract(70, "years")
        .format(DATETIME_SEARCH_FORMAT)
    );
    const diffDate = sBirthDate
      ? moment.utc().diff(moment(sBirthDate), "years") + 1
      : "-";
    const minEndDate = sStart_date
      ? new Date(DateUtils.getCurrentPlusOneTh(sStart_date, "YYYY-MM-DD"))
      : today;
    return (
      <Fragment>
        {/* ################## */}
        {/** Start - End Date **/}
        {/* ################## */}
        <div className="form-group">
          <div className="d-flex">
            <label>
              ระยะเวลาเอาประกัน{" "}
              <InfoIconComponent id="diffDateAssurance" text="วันที่เริ่มต้นความคุ้มครองต้องมากกว่าวันปัจจุบัน และเลือกล่วงหน้าได้ไม่เกิน 1 เดือน เวลาเริ่มต้น - สิ้นสุดความคุ้มครอง 16.30 น." />
            </label>
            <div className="ml-auto">
              <p className="text-dark-blue">
                <b>{diffDateAssurance}</b> ปี
              </p>
            </div>
          </div>
          <div className="d-flex">
            <DatePickerComponent
              minDate={today}
              maxDate={insure_maxDate}
              selected={sStart_date ? new Date(sStart_date) : ""}
              placeholderText="วันที่เริ่มต้น"
              onChange={date => onChangeDateModel(date)}
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              popperPlacement="top-start"
            />
            <SpaceBox />
            <DatePickerComponent
              className="disabled"
              disabled={true}
              selected={sEnd_date ? new Date(sEnd_date) : ""}
              placeholderText="วันที่สิ้นสุด"
              // onChange={date =>
              //   onChangeDateModel({ name: "sEnd_date", value: date })
              // }
              dateFormat="dd/MM/yyyy"
              popperPlacement="top-end"
              showTimeSelect={false}
            />
          </div>
        </div>
        {/* ################## */}
        {/*** End Date Picker **/}
        {/* ################## */}

        <div className="form-group">
          <label>{this._getLang("identity")}</label>
          <InputMask
            mask="9-9999-99999-99-9"
            maskChar="_"
            type="tel"
            value={sIDNo}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          >
            {inputProps => (
              <input
                // id={sIDNo}
                {...inputProps}
                className="form-control"
                placeholder={this._getLang("identityPlaceHolder")}
                name="sIDNo"
              />
            )}
          </InputMask>
        </div>
        <div className="form-group">
          <label>{this._getLang("gender")}</label>
          <div className="d-flex">
            <div
              className={`radio-button align-item-center ${
                sSex === "M" ? "active" : ""
              }`}
              onClick={() => onChangeModel({ name: "sSex", value: "M" })}
            >
              <div className="radio" />
              <p>{this._getLang("male")}</p>
            </div>
            <div
              className={`radio-button align-item-center ${
                sSex === "F" ? "active" : ""
              }`}
              onClick={() => onChangeModel({ name: "sSex", value: "F" })}
            >
              <div className="radio" />
              <p>{this._getLang("female")}</p>
            </div>
          </div>
        </div>
        <NameThComponent
          keyIndex={""}
          titles={this._getTitles(sSex, "TH")}
          sInitNameTH={sInitNameTH}
          sFirstNameTH={sFirstNameTH}
          sLastNameTH={sLastNameTH}
          onChange={onChangeModel}
        />
        <div className="form-group">
          <div className="d-flex">
            <label>{this._getLang("birthdate")}</label>
            <div className="ml-auto">
              <p className="text-dark-blue">
                <b>{diffDate} </b>
                {this._getLang("year")}
              </p>
            </div>
          </div>
          <DatePickerComponent
            selected={sBirthDate ? new Date(sBirthDate) : ""}
            minDate={minDate}
            maxDate={maxDate}
            datePrevious={60}
            placeholderText={this._getLang("birthdate")}
            onChange={date =>
              onChangeModel({ name: "sBirthDate", value: date })
            }
            dateFormat="dd/MM/yyyy"
            showTimeSelect={false}
            showMonthYearDropdown
            popperPlacement="top-start"
          />
        </div>
        <div className="form-group">
          <label>{this._getLang("ocupationPlaceHolder")}</label>
          <SelectComponent
            placeholder={this._getLang("ocupationPlaceHolder")}
            options={this.state.occupations}
            selected={sOccupation}
            onChange={selected =>
              onChangeModel({ name: "sOccupation", value: selected })
            }
          />
        </div>
        <div className="form-group">
          <label>{this._getLang("contact")}</label>
          <InputMask
            mask="9999999999"
            type="tel"
            value={sMobile}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          >
            {inputProps => (
              <input
                id={sMobile}
                {...inputProps}
                className="form-control"
                placeholder={this._getLang("contactPlaceHolder")}
                name="sMobile"
              />
            )}
          </InputMask>
        </div>
        <div className="form-group">
          <label>{this._getLang("email")}</label>
          <input
            id={sEmail}
            type="text"
            className="form-control"
            placeholder="name@email.com"
            name="sEmail"
            value={sEmail}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
      </Fragment>
    );
  }

  _renderAddressForm() {
    const { province } = this.state;
    const { step2 } = this.context;
    const {
      sNo,
      sMoo,
      sSoi,
      sRoad,
      sProvince,
      sDistrict,
      sCity,
      sZipcode,
      onChangeModel,
      onChangeModelProvinces
    } = step2;

    return (
      <Fragment>
        <div className="form-group d-flex">
          <input
            // id={sNo}
            type="text"
            className="form-control"
            placeholder={this._getLang("no")}
            name="sNo"
            value={sNo}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
          {this._SpaceBox()}
          <input
            // id={sMoo}
            type="text"
            className="form-control"
            placeholder={this._getLang("moo")}
            name="sMoo"
            value={sMoo}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <div className="form-group d-flex">
          <input
            // id={sSoi}
            type="text"
            className="form-control"
            placeholder={this._getLang("soi")}
            name="sSoi"
            value={sSoi}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
          {this._SpaceBox()}
          <input
            // id={sRoad}
            type="text"
            className="form-control"
            placeholder={this._getLang("road")}
            name="sRoad"
            value={sRoad}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <ProvincesComponent
          lang={"th"}
          langague={Step3Langague}
          provinces={{ sProvince, sDistrict, sCity, sZipcode }}
          onChange={object => onChangeModelProvinces(object)}
        />
      </Fragment>
    );
  }

  _renderAddressAsset() {
    const { province } = this.state;
    const { step2 } = this.context;
    const {
      onChangeModel,
      sNoOther,
      sMooOther,
      sSoiOther,
      sRoadOther,
      sProvinceOther,
      sDistrictOther,
      sCityOther,
      sZipcodeOther,
      sBuilding,
      onChangeModelProvinces
    } = step2;

    return (
      <Fragment>
        <div className="form-group d-flex">
          <input
            // id={sNo}
            type="text"
            className="form-control"
            placeholder={this._getLang("no")}
            name="sNoOther"
            value={sNoOther}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
          {this._SpaceBox()}
          <input
            // id={sMoo}
            type="text"
            className="form-control"
            placeholder={this._getLang("moo")}
            name="sMooOther"
            value={sMooOther}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
        {this._SpaceBox()}
        <div className="form-group d-flex">
          <input
            // id={sMoo}
            type="text"
            className="form-control"
            placeholder={this._getLang("buildingVillage")}
            name="sBuilding"
            value={sBuilding}
            onChange={(e) =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <div className="form-group d-flex">
          <input
            // id={sSoi}
            type="text"
            className="form-control"
            placeholder={this._getLang("soi")}
            name="sSoiOther"
            value={sSoiOther}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
          {this._SpaceBox()}
          <input
            // id={sRoad}
            type="text"
            className="form-control"
            placeholder={this._getLang("road")}
            name="sRoadOther"
            value={sRoadOther}
            onChange={e =>
              onChangeModel({ name: e.target.name, value: e.target.value })
            }
          />
        </div>

        <ProvincesOtherComponent
          lang={"th"}
          langague={Step3Langague}
          provinces={{
            sProvinceOther,
            sDistrictOther,
            sCityOther,
            sZipcodeOther
          }}
          onChange={object => onChangeModelProvinces(object)}
        />
      </Fragment>
    );
  }

  _renderRadioAddress = () => {
    const { step2 } = this.context;
    const { onChangeModel, onChangeAddressOther, isOtherAddress } = step2;
    // const isSameIdentity = 1;
    const onChange = value => {
      onChangeModel({ name: "isOtherAddress", value: value });
      // onChangeAddressOther({ name: "sNoOther", value: value });
    };

    return (
      <Fragment>
        <div className="form-group">
          <div
            className={`address-radio radio-button align-item-center w-100 ${
              isOtherAddress === 1 ? "active" : ""
            }`}
            onClick={() => onChange(1)}
          >
            <div className="radio" />
            <p>ตรงกับที่ตั้งทรัพย์สิน</p>
          </div>
        </div>
        <div className="form-group">
          <div
            className={`address-radio radio-button align-item-center w-100 ${
              isOtherAddress === 2 ? "active" : ""
            }`}
            onClick={() => onChange(2)}
          >
            <div className="radio" />
            <p>ที่อยู่อื่นๆ (ระบุ)</p>
          </div>
        </div>
      </Fragment>
    );
  };

  _renderBenefit = () => {
    const { step2 } = this.context;
    const {
      sBank = { label: "โปรดเลือก", value: "000" },
      sOffice,
      isOtherBenefit,
      benefitType,
      onChangeModel
    } = step2;

    // const onChange = value => {
    //   onChangeModel({ name: "isOtherBenefit", value: value });
    // };

    return (
      <Fragment>
        <div className="form-group">
          <SelectComponent
            placeholder={this._getLang("pleaseChoose")}
            options={BENEFITS}
            selected={benefitType}
            onChange={selected =>
              onChangeModel({ name: "benefitType", value: selected })
            }
          />
        </div>
      </Fragment>
    );
  };

  _renderPersonalBenefit(person, key) {
    const { benefitTitles } = this.state;
    const { step2 } = this.context;
    const { onChangeBenefit } = step2;
    const { sInit, sFirstName, sLastName, sRelation } = person;

    return (
      <Fragment>
        <div className="form-group">
          <label>ชื่อ/นามสกุล (ภาษาไทย)</label>
          <SelectComponent
            placeholder="คำนำหน้าชื่อ"
            options={benefitTitles}
            selected={sInit}
            onChange={selected =>
              onChangeBenefit({ key, name: "sInit", value: selected })
            }
          />
          <input
            id={`sFirstName}`}
            type="text"
            className="form-control mt-2"
            placeholder="ชื่อ"
            name="sFirstName"
            value={sFirstName}
            onChange={e =>
              onChangeBenefit({
                key,

                name: e.target.name,
                value: e.target.value
              })
            }
          />
          <input
            id={`sLastName`}
            type="text"
            className="form-control mt-2"
            placeholder="นามสกุล"
            name="sLastName"
            value={sLastName}
            onChange={e =>
              onChangeBenefit({
                key,

                name: e.target.name,
                value: e.target.value
              })
            }
          />
        </div>
        <div className="form-group">
          <label>ความสัมพันธ์</label>
          <SelectComponent
            placeholder="โปรดเลือก"
            options={RELATIONS}
            selected={sRelation}
            onChange={selected =>
              onChangeBenefit({ key, name: "sRelation", value: selected })
            }
          />
        </div>
      </Fragment>
    );
  }

  _renderLegalBenefit() {
    const { step2 } = this.context;
    const { onChangeModel } = step2;
    const { legalBenefit } = step2;

    return (
      <Fragment>
        <div className="form-group">
          <input
            type="text"
            className="form-control mt-2"
            placeholder="ชื่อนิติบุคคล"
            name="legalBenefit"
            value={legalBenefit}
            onChange={e =>
              onChangeModel({
                name: e.target.name,
                value: e.target.value
              })
            }
          />
        </div>
      </Fragment>
    );
  }
  _renderBankBenefit() {
    const { step2 } = this.context;
    const { bankBenefit, companyBenefit, onChangeModel } = step2;
    return (
      <Fragment>
        <div className="form-group">
          {/* <label className="text-helper">
            * สามารถเลือกระบุสถาบันการเงินหรือบริษัทได้อย่างใดอย่างหนึ่ง
          </label> */}

          <SelectComponent
            placeholder={this._getLang("pleaseChoose")}
            options={BANKS}
            disabled={companyBenefit ? true : false}
            selected={bankBenefit}
            onChange={selected =>
              onChangeModel({ name: "bankBenefit", value: selected })
            }
          />
          <input
            type="text"
            className="form-control mt-2"
            placeholder="ชื่อบริษัท"
            name="companyBenefit"
            value={companyBenefit}
            disabled={bankBenefit && bankBenefit.value !== "000" ? true : false}
            onChange={e =>
              onChangeModel({
                name: e.target.name,
                value: e.target.value
              })
            }
          />
        </div>
      </Fragment>
    );
  }
  _SpaceBox() {
    return <SpaceBox w={"14px"} />;
  }
  render() {
    const { step2 } = this.context;
    const {
      isOtherAddress,
      isOtherBenefit,
      benefitType,
      benefits,
      onAddBenefit,
      onRemoveBenefit
    } = step2;
    const benefitCount = benefits ? benefits.length : 1;

    return (
      <Fragment>
        <div className="form-wrapper">{this._renderPresonForm()}</div>
        <div className="form-group address-header">
          <label>ที่ตั้งทรัพย์สิน</label>
        </div>
        <div className="form-wrapper">{this._renderAddressAsset()}</div>
        <div className="form-group address-header mb-0">
          <label>ที่อยู่ผู้เอาประกัน</label>
        </div>
        <div className="form-wrapper select-horizontal">
          {isOtherAddress === 1 ? (
            this._renderRadioAddress()
          ) : (
            <Fragment>
              {this._renderRadioAddress()}
              {isOtherAddress && this._renderAddressForm()}
            </Fragment>
          )}
        </div>
        {/* Benefit Section */}
        <div className="form-group address-header mb-0">
          <label>ผู้รับประโยชน์</label>
        </div>
        <div className="form-wrapper select-horizontal">
          {this._renderBenefit()}
        </div>
        <Fragment>
          {benefitType.label === "บุคคลธรรมดา" ? (
            <Fragment>
              {benefits &&
                benefits.map((person, indexIn) => {
                  return (
                    <Fragment key={indexIn}>
                      <div className="form-group address-header mb-0">
                        <label>ผู้รับประโยชน์ {indexIn + 1} </label>
                      </div>
                      <div className="form-wrapper">
                        {this._renderPersonalBenefit(person, indexIn)}
                      </div>
                    </Fragment>
                  );
                })}
              <div className="form-wrapper">
                <div className="form-group benefit-wrapper">
                  {benefitCount === 1 ? (
                    <button
                      className="btn btn-seconday m-auto d-flex"
                      onClick={() => onAddBenefit()}
                    >
                      <p>เพิ่มผู้รับประโยชน์</p>{" "}
                      <img src={AddRound} width="24px" height="24px" />
                    </button>
                  ) : benefitCount === 2 ? (
                    <button
                      className="btn btn-seconday m-auto d-flex"
                      onClick={() => onRemoveBenefit()}
                    >
                      <p>ลบผู้รับประโยชน์</p>{" "}
                      <img src={DelRound} width="24px" height="24px" />
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </Fragment>
          ) : benefitType.label === "นิติบุคคล" ? (
            <div className="form-wrapper pt-0">
              {this._renderLegalBenefit()}
            </div>
          ) : benefitType.label === "สถาบันการเงิน" ? (
            <Fragment>
              <div className="form-wrapper pt-0">
                <p className="text-helper">
                  * สามารถเลือกระบุสถาบันการเงินหรือบริษัทได้อย่างใดอย่างหนึ่ง
                </p>
              </div>
              <div className="form-wrapper">{this._renderBankBenefit()}</div>
            </Fragment>
          ) : (
            ""
          )}
        </Fragment>
        {/* ); })} */}
      </Fragment>
    );
  }
}

FireAssuranceStep2.contextType = FireAssuranceContext;
export default withRouter(FireAssuranceStep2);
